import React, { useEffect } from "react";
import Industrialbanner from "./Industrialbanner";
import Industrialabout from "./Industrialabout";
import Industrialfeatures from "./Industrialfeatures";
import Industrialcards from "./Industrialcards";
import Webbanner from "./Webbanner";

const Industrialautomate = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Industrialbanner/>
      
      <Industrialabout/>

      <Industrialfeatures/>
      <Industrialcards/>
    </div>
  );
};

export default Industrialautomate;